import { createActionCreator, paramsEncode } from '../../../utils/';
import request from '../../../utils/request';
import constant from './constant';
import Urls from '../../../../config/index';
const indexUrl = Urls.PartnerUrl.indexList;

export const createLoadingAction = createActionCreator(constant.ListLoading, loading => loading); // 流加载
export const createIndexListAction = createActionCreator(constant.INDEXLIST, list => list); // 通知列表
// 获取通知列表
export const getIndexList = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let response = await request(indexUrl);
            dispatch(createIndexListAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/exportData/actions.js